import React from "react";
import DropdownMenuDemo from "./PromotionRuleDropdown";
import { isObject } from "lodash";
import { cartProductOptions } from "./data";
import { useContext } from "react";
import { PlatformContext } from "./AddPromotions";

export default function ThenRuleView({
  data,
  thenRuleOpen,
  setThenRuleOpen,
  rulesStructure,
  setData,
  selectedRuleTypeRules,
  isThenMenuHappenOpen,
  setThenMenuHappenOpen,
  updateRulesRef,
  updateRuleValue,
  orderTotalExeedValue = 0,
}) {
  const platform = useContext(PlatformContext);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="fs-large text-gray-400 font-medium" style={{ display: "flex", flexWrap: "wrap" }}>
        {/* Render a dropdown if no 'thenRules' are present */}
        {data?.thenRules?.length === 0 && (
          <>
            <DropdownMenuDemo
              key="then-do-this"
              menuTrigger={
                <span className={thenRuleOpen ? "!text-blue-400 underline bg-red-400 fs-large" : ""}>
                  Then
                </span>
              }
              menuOptions={selectedRuleTypeRules.thenRules || []}
              isOpen={thenRuleOpen}
              setOpen={() => setThenRuleOpen(!thenRuleOpen)}
              ruleType="then"
              rule="this"
              selectRuleHandler={({ ruleValue }) => {
                const selectedRule = selectedRuleTypeRules.thenRules?.find(
                  (item) => item.value === ruleValue
                );
                if (selectedRule) {
                  setData((prevData) => ({
                    ...prevData,
                    showThenError: false,
                    thenRules: [selectedRule],
                  }));
                }
              }}
              type="select"
              showError={data.showThenError}
              ruleId="then_rule"
              inputValue={data?.ruleType}
            />
            <span>Apply</span>


          </>

        )}

        {/* Iterate over 'thenRules' to render each rule */}
        {data?.thenRules?.map((thenRule) => (
          <React.Fragment key={thenRule.value}>
            {!(
              thenRule?.groupRule?.isGroupRule &&
              thenRule?.groupRule?.groupRule?.value === "buy_product" &&
              thenRule?.groupRule?.groupRule?.selectedValue === "any_product"
            ) && (
                <>
                  <DropdownMenuDemo
                    key="then-do-this"
                    menuTrigger={
                      <span
                        className={`underline text-blue-400 ${thenRuleOpen ? "!text-blue-400 underline bg-red-400" : ""
                          } ${data.showThenError ? "!text-red-400 !decoration-red-400" : ""}`}
                      >
                        Then
                      </span>
                    }
                    menuOptions={selectedRuleTypeRules.thenRules || []}
                    isOpen={thenRuleOpen}
                    setOpen={() => setThenRuleOpen(!thenRuleOpen)}
                    ruleType="then"
                    rule="this"
                    selectRuleHandler={({ ruleValue }) => {
                      const selectedRule = selectedRuleTypeRules.thenRules?.find(
                        (item) => item.value === ruleValue
                      );
                      if (selectedRule) {
                        setData((prevData) => ({
                          ...prevData,
                          showThenError: false,
                          thenRules: [selectedRule],
                        }));
                      }
                    }}
                    type="select"
                    showError={data.showThenError}
                    ruleId="then_rule"
                    inputValue={data?.ruleType}
                  />
                  {!(
                    thenRule &&
                    thenRule?.groupRule?.value === "get_one_product" &&
                    thenRule?.groupRule?.groupRule?.selectedValue === "any_product"
                  ) && <>{thenRule.title && <span>{thenRule.title}</span>}</>}

                  {/* group level one  */}
                  {thenRule.attributes === "each_or_any" && thenRule.selectedValue === "each" && (
                    <>
                      <DropdownMenuDemo
                        key={thenRule.groupRule.value}
                        menuTrigger={
                          <>
                            {thenRule?.groupRule?.inputType === "dollar" &&
                              thenRule?.groupRule.title &&
                              "$"}
                            {Array.isArray(thenRule?.groupRule?.selectedValue) ? (
                              thenRule.groupRule.selectedValue?.length > 0 ? (
                                <>
                                  {thenRule.groupRule.selectedValue
                                    ?.slice(0, 2)
                                    .map((value) =>
                                      thenRule.groupRule?.listType === "category"
                                        ? `${value?.categoryName}`
                                        : thenRule.groupRule?.listType === "brand"
                                          ? `${value?.brandName}`
                                          : `${value?.display_name} - ${value?.SKU}`
                                    )
                                    .join(", ") || thenRule.groupRule.highlightText}
                                  {thenRule.groupRule.selectedValue.length > 2 && (
                                    <span
                                      className="chip"
                                      data-tooltip-id="tooltip"
                                      data-tooltip-content={
                                        thenRule.groupRule.selectedValue
                                          .map((value) =>
                                            thenRule.groupRule?.listType === "category"
                                              ? `${value?.categoryName}`
                                              : thenRule.groupRule?.listType === "brand"
                                                ? `${value?.brandName}`
                                                : `${value?.display_name} - ${value?.SKU}`
                                          )
                                          .join(", ") || thenRule.groupRule.highlightText
                                      }
                                    >{`+${thenRule.groupRule.selectedValue.length - 2}`}</span>
                                  )}
                                </>
                              ) : (
                                thenRule.groupRule.highlightText
                              )
                            ) : isObject(thenRule?.groupRule?.selectedValue) ? (
                              thenRule?.groupRule?.listType === "category" ? (
                                thenRule?.groupRule?.selectedValue?.categoryName || "category"
                              ) : thenRule?.groupRule?.listType === "brand" ? (
                                thenRule?.groupRule?.selectedValue?.brandName || "brand"
                              ) : (
                                thenRule?.groupRule?.selectedValue?.display_name || "product"
                              )
                            ) : thenRule?.groupRule?.selectedValue === "any_product" ? (
                              "Then Get Any Product"
                            ) : (
                              (thenRule?.groupRule?.type === "select" &&
                                Array.isArray(thenRule?.groupRule?.options)
                                ? thenRule.groupRule.options.find(
                                  (o) => o.value === thenRule.groupRule.selectedValue
                                )?.title
                                : null) ||
                              thenRule?.groupRule?.selectedValue ||
                              thenRule.groupRule.highlightText ||
                              "select"
                            )}
                            {thenRule?.groupRule?.inputType === "percentage" &&
                              thenRule?.groupRule.title &&
                              "%"}
                          </>
                        }
                        menuOptions={
                          thenRule.groupRule?.listType === "category"
                            ? [] // Categories not handled in ThenRuleView yet?
                            : thenRule.groupRule?.listType === "brand"
                              ? []
                              : thenRule.groupRule.type === "select"
                                ? thenRule.groupRule.options
                                : selectedRuleTypeRules.thenRules || []
                        }
                        isOpen={thenRule.groupRule.isOpen}
                        setOpen={() => {
                          let updatedThenRules = [...updateRulesRef.current.thenRules].map((rule) => {
                            if (rule.groupRule.value === thenRule.groupRule.value && rule.groupRule) {
                              return {
                                ...rule,
                                groupRule: {
                                  ...rule.groupRule,
                                  isOpen: !rule.groupRule.isOpen,

                                  // selectedValue: rule.groupRule.selectedValue
                                },
                              };
                            }
                            return rule;
                          });
                          updateRulesRef.current = {
                            ...data,
                            thenRules: [...updatedThenRules],
                          };
                          setData({
                            ...data,
                            thenRules: updatedThenRules,
                          });
                        }}
                        ruleType="then"
                        rule="happen"
                        selectRuleHandler={({ ruleValue }) => {
                          if (
                            thenRule.groupRule.type === "select" ||
                            thenRule.groupRule.type === "list"
                          ) {
                            const selectedRule = data.thenRules?.find(
                              (item) => item.groupRule.value === thenRule.groupRule.value
                            );
                            if (selectedRule) {
                              const index = data.thenRules.indexOf(selectedRule);
                              let existingRule = [...data.thenRules];
                              existingRule[index] = {
                                ...selectedRule,
                                isOpen: false,
                                isShowError: false,
                                groupRule: {
                                  ...selectedRule.groupRule,
                                  selectedValue: ruleValue,
                                  isShowError: false,
                                  // highlightText: ruleValue,
                                },
                              };
                              updateRulesRef.current = {
                                ...data,
                                thenRules: [...existingRule],
                              };
                              setData((prev) => {
                                return {
                                  ...prev,
                                  thenRules: [...existingRule],
                                };
                              });
                            }
                            return;
                          }
                          if (thenRule.groupRule.type === "input") {
                            const updatedRules = updateRuleValue({
                              rules: data.thenRules,
                              ruleValue,
                              ruleId: thenRule.groupRule.value,
                              isGroupRule: thenRule.isGroupRule,
                            });
                            setData({
                              ...data,
                              thenRules: updatedRules,
                            });
                            return;
                          }
                          let existingRule = [...data.thenRules];
                          const selectedRule = selectedRuleTypeRules.thenRules?.find(
                            (item) => item.value === ruleValue
                          );
                          if (selectedRule) {
                            existingRule = [...existingRule, selectedRule];
                          }
                          const thenRuleArray = data.thenRules.some((item) =>
                            selectedRuleTypeRules.thenRules.find(
                              (_item) => _item.value === item.value
                            )
                          );
                          if (thenRuleArray) {
                            let findRule = data.thenRules.find((item) =>
                              selectedRuleTypeRules.thenRules.find(
                                (_item) => _item.value === item.value
                              )
                            );
                            if (findRule) {
                              existingRule = existingRule.filter(
                                (item) => item.value !== findRule?.value
                              );
                            }
                          }
                          setData({
                            ...data,
                            thenRules: existingRule,
                          });
                        }}
                        rules={selectedRuleTypeRules.thenRules}
                        type={thenRule.groupRule?.type}
                        inputType={thenRule.groupRule?.inputType}
                        listType={thenRule.groupRule?.listType}
                        ruleId={thenRule.groupRule?.value}
                        inputValue={thenRule.groupRule.selectedValue}
                        isGroupRule={true}
                        showError={thenRule?.groupRule?.isShowError}
                      />
                    </>
                  )}
                  <DropdownMenuDemo
                    key={thenRule.value}
                    menuTrigger={
                      <span
                        className="underline"
                        style={{
                          color: thenRule.isShowError ? "red" : "text-blue-400",
                          textDecorationColor: thenRule.isShowError ? "red" : "#60a5fa",
                        }}
                      >
                        {thenRule.inputType === "dollar" && thenRule?.title && "$"}
                        {Array.isArray(thenRule?.selectedValue) ? (
                          thenRule.selectedValue?.length > 0 ? (
                            <>
                              {thenRule.selectedValue
                                ?.slice(0, 2)
                                .map((value) =>
                                  thenRule?.listType === "category"
                                    ? `${value?.categoryName}`
                                    : thenRule?.listType === "brand"
                                      ? `${value?.brandName}`
                                      : `${value?.display_name} - ${value?.SKU}`
                                )
                                .join(", ") ||
                                thenRule.highlightText ||
                                "Select"}
                              {thenRule.selectedValue.length > 2 && (
                                <span
                                  className="chip"
                                  data-tooltip-id="tooltip"
                                  data-tooltip-content={
                                    thenRule.selectedValue
                                      .map((value) =>
                                        thenRule?.listType === "category"
                                          ? `${value?.categoryName}`
                                          : thenRule?.listType === "brand"
                                            ? `${value?.brandName}`
                                            : `${value?.display_name} - ${value?.SKU}`
                                      )
                                      .join(", ") || thenRule.highlightText
                                  }
                                >{`+${thenRule.selectedValue.length - 2}`}</span>
                              )}
                            </>
                          ) : (
                            thenRule.highlightText
                          )
                        ) : isObject(thenRule?.selectedValue) ? (
                          thenRule?.listType === "category" ? (
                            thenRule?.selectedValue?.categoryName || "category"
                          ) : thenRule?.listType === "brand" ? (
                            thenRule?.selectedValue?.brandName || "brand"
                          ) : (
                            thenRule?.selectedValue?.display_name || "product"
                          )
                        ) : thenRule?.selectedValue === "any_product" ? (
                          "TGet Any Product"
                        ) : thenRule?.type !== "one-level" ? (
                          (thenRule?.type === "select" && Array.isArray(thenRule?.options)
                            ? thenRule.options.find((o) => o.value === thenRule.selectedValue)?.title
                            : null) ||
                          thenRule?.selectedValue ||
                          thenRule?.highlightText ||
                          "Select"
                        ) : (
                          ""
                        )}
                        {thenRule.inputType === "percentage" && thenRule?.title && "%"}
                      </span>
                    }
                    menuOptions={
                      thenRule?.listType === "brand"
                        ? []
                        : thenRule?.type === "select"
                          ? thenRule?.options
                          : selectedRuleTypeRules.thenRules || []
                    }
                    isOpen={isThenMenuHappenOpen}
                    setOpen={() => setThenMenuHappenOpen(!isThenMenuHappenOpen)}
                    ruleType="then"
                    rule="happen"
                    selectRuleHandler={({ ruleValue }) => {
                      let existingRule = [...data.thenRules];
                      if (thenRule.type === "select" || thenRule.type === "list") {
                        const selectedRule = existingRule.find((item) => item.value === thenRule.value);
                        if (selectedRule) {
                          const index = existingRule.indexOf(selectedRule);
                          existingRule[index] = {
                            ...selectedRule,
                            selectedValue: ruleValue,
                            isOpen: false,
                            isShowError: false,
                          };
                          setData((prevData) => ({
                            ...prevData,
                            thenRules: existingRule,
                          }));
                        }
                        return;
                      }
                      if (thenRule.type === "input") {
                        const updatedRules = updateRuleValue({
                          rules: data.thenRules,
                          ruleValue,
                          ruleId: thenRule.value,
                          isGroupRule: false,
                        });
                        setData((prevData) => ({
                          ...prevData,
                          thenRules: updatedRules,
                        }));
                        return;
                      }
                      const selectedRule = selectedRuleTypeRules.thenRules?.find(
                        (item) => item.value === ruleValue
                      );
                      if (selectedRule) {
                        existingRule.push(selectedRule);
                      }
                      const thenRuleArray = data.thenRules.some((item) =>
                        selectedRuleTypeRules.thenRules.find(
                          (_item) => _item.value === item.value
                        )
                      );
                      if (thenRuleArray) {
                        existingRule = existingRule.filter((item) => item.value !== thenRule.value);
                      }
                      setData((prevData) => ({
                        ...prevData,
                        thenRules: existingRule,
                      }));
                    }}
                    type={thenRule?.type}
                    inputType={thenRule?.inputType}
                    listType={thenRule?.listType}
                    ruleId={thenRule?.value}
                    rules={selectedRuleTypeRules.thenRules}
                    isGroupRule={false}
                    inputValue={thenRule.selectedValue}
                    showError={thenRule.isShowError}
                    maxInputValue={orderTotalExeedValue}
                  />
                  {thenRule?.endTitle && <span>{thenRule?.endTitle}</span>}
                  {/* group level one  */}
                </>
              )}
            {/* group level two  */}
            {thenRule.isGroupRule && (
              <>
                {!(
                  thenRule &&
                  thenRule.groupRule.value === "get_one_product" &&
                  thenRule.groupRule.groupRule.selectedValue === "any_product"
                ) && (
                    <>
                      {thenRule.groupRule.title && (
                        <span>
                          {thenRule.value === "flash_sale_discount" && thenRule.endTitle ? "\u00A0" : ""}
                          {thenRule.groupRule.title}
                        </span>
                      )}

                      {thenRule.attributes === "each_or_any" &&
                        thenRule.selectedValue === "each" ? null : (
                        <>
                          <DropdownMenuDemo
                            key={thenRule.groupRule.value}
                            menuTrigger={
                              <>
                                {["products"].includes(thenRule.groupRule?.selectedValue) &&
                                  thenRule.groupRule?.value === "on_cart_product" ? (
                                  cartProductOptions?.find((item) => item.value === "products")
                                    ?.highLightText
                                ) : (
                                  <>
                                    {thenRule?.groupRule?.inputType === "dollar" &&
                                      thenRule?.groupRule.title &&
                                      "$"}
                                    {Array.isArray(thenRule?.groupRule?.selectedValue) ? (
                                      thenRule.groupRule.selectedValue?.length > 0 ? (
                                        <>
                                          {thenRule.groupRule.selectedValue
                                            ?.slice(0, 2)
                                            .map((value) =>
                                              thenRule.groupRule?.listType === "category"
                                                ? `${value?.categoryName}`
                                                : thenRule.groupRule?.listType === "brand"
                                                  ? `${value?.brandName}`
                                                  : `${value?.display_name} - ${value?.SKU}`
                                            )
                                            .join(", ") || thenRule.groupRule.highlightText}
                                          {thenRule.groupRule.selectedValue.length > 2 && (
                                            <span
                                              className="chip"
                                              data-tooltip-id="tooltip"
                                              data-tooltip-content={
                                                thenRule.groupRule.selectedValue
                                                  .map((value) =>
                                                    thenRule.groupRule?.listType === "category"
                                                      ? `${value?.categoryName}`
                                                      : thenRule.groupRule?.listType === "brand"
                                                        ? `${value?.brandName}`
                                                        : `${value?.display_name} - ${value?.SKU}`
                                                  )
                                                  .join(", ") || thenRule.groupRule.highlightText
                                              }
                                            >{`+${thenRule.groupRule.selectedValue.length - 2}`}</span>
                                          )}
                                        </>
                                      ) : (
                                        thenRule.groupRule.highlightText
                                      )
                                    ) : isObject(thenRule?.groupRule?.selectedValue) ? (
                                      thenRule?.groupRule?.listType === "category" ? (
                                        thenRule?.groupRule?.selectedValue?.categoryName || "category"
                                      ) : thenRule?.groupRule?.listType === "brand" ? (
                                        thenRule?.groupRule?.selectedValue?.brandName || "brand"
                                      ) : (
                                        thenRule?.groupRule?.selectedValue?.display_name || "product"
                                      )
                                    ) : thenRule?.groupRule?.selectedValue === "any_product" ? (
                                      "Then Get Any Product"
                                    ) : (
                                      (thenRule?.groupRule?.type === "select" &&
                                        Array.isArray(thenRule?.groupRule?.options)
                                        ? thenRule.groupRule.options.find(
                                          (o) => o.value === thenRule.groupRule.selectedValue
                                        )?.title
                                        : null) ||
                                      thenRule?.groupRule?.selectedValue ||
                                      thenRule.groupRule.highlightText ||
                                      "select"
                                    )}
                                    {thenRule?.groupRule?.inputType === "percentage" &&
                                      thenRule?.groupRule.title &&
                                      "%"}
                                  </>
                                )}
                              </>
                            }
                            menuOptions={
                              thenRule.groupRule?.listType === "brand"
                                ? []
                                : thenRule.groupRule.type === "select"
                                  ? thenRule.groupRule.options
                                  : selectedRuleTypeRules.thenRules || []
                            }
                            isOpen={thenRule.groupRule.isOpen}
                            setOpen={() => {
                              let updatedThenRules = [...updateRulesRef.current.thenRules].map(
                                (rule) => {
                                  if (
                                    rule.groupRule.value === thenRule.groupRule.value &&
                                    rule.groupRule
                                  ) {
                                    return {
                                      ...rule,
                                      groupRule: {
                                        ...rule.groupRule,
                                        isOpen: !rule.groupRule.isOpen,
                                        // selectedValue: rule.groupRule.selectedValue
                                      },
                                    };
                                  }
                                  return rule;
                                }
                              );
                              updateRulesRef.current = {
                                ...data,
                                thenRules: [...updatedThenRules],
                              };
                              setData({
                                ...data,
                                thenRules: updatedThenRules,
                              });
                            }}
                            ruleType="then"
                            rule="happen"
                            selectRuleHandler={({ ruleValue }) => {
                              if (
                                thenRule.groupRule.type === "select" ||
                                thenRule.groupRule.type === "list"
                              ) {
                                const selectedRule = data.thenRules?.find(
                                  (item) => item.groupRule.value === thenRule.groupRule.value
                                );
                                if (selectedRule) {
                                  const index = data.thenRules.indexOf(selectedRule);
                                  let existingRule = [...data.thenRules];
                                  existingRule[index] = {
                                    ...selectedRule,
                                    isOpen: false,
                                    isShowError: false,
                                    groupRule: {
                                      ...selectedRule.groupRule,
                                      selectedValue: ruleValue,
                                      isShowError: false,
                                      // highlightText: ruleValue,
                                    },
                                  };
                                  updateRulesRef.current = {
                                    ...data,
                                    thenRules: [...existingRule],
                                  };
                                  setData((prev) => {
                                    return {
                                      ...prev,
                                      thenRules: [...existingRule],
                                    };
                                  });
                                }
                                return;
                              }
                              if (thenRule.groupRule.type === "input") {
                                const updatedRules = updateRuleValue({
                                  rules: data.thenRules,
                                  ruleValue,
                                  ruleId: thenRule.groupRule.value,
                                  isGroupRule: thenRule.isGroupRule,
                                });
                                setData({
                                  ...data,
                                  thenRules: updatedRules,
                                });
                                return;
                              }
                              let existingRule = [...data.thenRules];
                              const selectedRule = rulesStructure[data.ruleType].thenRules?.find(
                                (item) => item.value === ruleValue
                              );
                              if (selectedRule) {
                                existingRule = [...existingRule, selectedRule];
                              }
                              const thenRuleArray = data.thenRules.some((item) =>
                                rulesStructure[data.ruleType].thenRules.find(
                                  (_item) => _item.value === item.value
                                )
                              );
                              if (thenRuleArray) {
                                let findRule = data.thenRules.find((item) =>
                                  rulesStructure[data.ruleType].thenRules.find(
                                    (_item) => _item.value === item.value
                                  )
                                );
                                if (findRule) {
                                  existingRule = existingRule.filter(
                                    (item) => item.value !== findRule?.value
                                  );
                                }
                              }
                              setData({
                                ...data,
                                thenRules: existingRule,
                              });
                            }}
                            rules={selectedRuleTypeRules.thenRules}
                            type={thenRule.groupRule?.type}
                            inputType={thenRule.groupRule?.inputType}
                            listType={thenRule.groupRule?.listType}
                            ruleId={thenRule.groupRule?.value}
                            inputValue={thenRule.groupRule.selectedValue}
                            isGroupRule={true}
                            showError={thenRule?.groupRule?.isShowError}
                          />
                        </>
                      )}
                    </>
                  )}

                {!["each_or_any"].includes(thenRule?.attributes) && thenRule?.groupRule?.endTitle && (
                  <span>{thenRule?.groupRule?.endTitle}</span>
                )}

                {(thenRule?.groupRule?.groupRule?.isGroupRule || false) &&
                  thenRule.groupRule?.groupRule.title && (
                    <span>{thenRule.groupRule?.groupRule.title}</span>
                  )}

                {/* group level two  */}

                {/* nested group rule  */}

                {thenRule.groupRule?.groupRule &&
                  thenRule.groupRule &&
                  (thenRule.attributes === "each_or_any" ||
                    thenRule.attributes === "upto_discount" ||
                    thenRule.groupRule.attributes === "upto_discount" ||
                    thenRule.groupRule.attributes === "more_to_get" ||
                    thenRule.attributes === "bogo_get_quantity" ||
                    ["products", "specific_product", "category", "brand"].includes(thenRule.groupRule?.selectedValue) ||
                    thenRule.groupRule?.value === "flash_sale_start_time" ||
                    thenRule.groupRule?.groupRule?.value === "flash_sale_end_time") && (
                    <>
                      <DropdownMenuDemo
                        key={thenRule.groupRule?.groupRule.value}
                        menuTrigger={
                          ["products", "specific_product", "category", "brand"].includes(thenRule.groupRule?.groupRule?.selectedValue) &&
                            thenRule.groupRule?.groupRule?.value === "on_cart_product" ? (
                            (() => {
                              const sv = thenRule.groupRule?.groupRule?.selectedValue;
                              const inner = thenRule.groupRule?.groupRule?.groupRule;
                              if (sv === "category" && Array.isArray(inner?.selectedValue) && inner.selectedValue.length > 0) {
                                return inner.selectedValue.map((c) => c?.categoryName).filter(Boolean).join(", ");
                              }
                              if (sv === "brand" && Array.isArray(inner?.selectedValue) && inner.selectedValue.length > 0) {
                                return inner.selectedValue.map((b) => b?.brandName).filter(Boolean).join(", ");
                              }
                              return cartProductOptions?.find((item) => item.value === sv)?.highLightText || "Select";
                            })()
                          ) : (
                            <>
                              {thenRule?.groupRule?.groupRule?.inputType === "dollar" &&
                                thenRule?.groupRule?.groupRule?.title &&
                                "$"}
                              {Array.isArray(thenRule?.groupRule?.groupRule?.selectedValue) ? (
                                thenRule.groupRule?.groupRule.selectedValue?.length > 0 ? (
                                  <>
                                    {thenRule.groupRule?.groupRule.selectedValue
                                      ?.slice(0, 2)
                                      .map((value) =>
                                        thenRule.groupRule?.groupRule?.listType === "category"
                                          ? `${value?.categoryName}`
                                          : thenRule.groupRule?.groupRule?.listType === "brand"
                                            ? `${value?.brandName}`
                                            : `${value?.display_name} - ${value?.SKU}`
                                      )
                                      .join(", ") ||
                                      thenRule.groupRule?.groupRule.highlightText ||
                                      "Select"}
                                    {thenRule.groupRule?.groupRule.selectedValue.length > 2 && (
                                      <span
                                        className="chip"
                                        data-tooltip-id="tooltip"
                                        data-tooltip-content={
                                          thenRule.groupRule?.groupRule.selectedValue
                                            .map((value) =>
                                              thenRule.groupRule?.groupRule?.listType === "category"
                                                ? `${value?.categoryName}`
                                                : thenRule.groupRule?.groupRule?.listType === "brand"
                                                  ? `${value?.brandName}`
                                                  : `${value?.display_name} - ${value?.SKU}`
                                            )
                                            .join(", ") ||
                                          thenRule.groupRule?.groupRule.highlightText ||
                                          "Select"
                                        }
                                      >{`+${thenRule.groupRule?.groupRule.selectedValue.length - 2
                                        }`}</span>
                                    )}
                                  </>
                                ) : (
                                  thenRule.groupRule?.groupRule.highlightText || "Select"
                                )
                              ) : isObject(thenRule?.groupRule?.groupRule?.selectedValue) ? (
                                thenRule?.groupRule?.groupRule?.listType === "category" ? (
                                  thenRule?.groupRule?.groupRule?.selectedValue?.categoryName ||
                                  "category"
                                ) : thenRule?.groupRule?.groupRule?.listType === "brand" ? (
                                  thenRule?.groupRule?.groupRule?.selectedValue?.brandName || "brand"
                                ) : (
                                  thenRule?.groupRule?.groupRule?.selectedValue?.display_name ||
                                  "product"
                                )
                              ) : thenRule?.groupRule?.groupRule?.selectedValue === "any_product" ? (
                                "Then Get Any Product"
                              ) : (
                                (thenRule?.groupRule?.groupRule?.type === "select" &&
                                  Array.isArray(thenRule?.groupRule?.groupRule?.options)
                                  ? thenRule.groupRule.groupRule.options.find(
                                    (o) => o.value === thenRule.groupRule.groupRule.selectedValue
                                  )?.title
                                  : null) ||
                                thenRule?.groupRule?.groupRule?.selectedValue ||
                                (thenRule?.groupRule?.groupRule?.value === "on_cart_product"
                                  ? "Select (cart, products…)"
                                  : thenRule.groupRule?.groupRule?.highlightText) ||
                                "select"
                              )}
                              {thenRule?.groupRule?.groupRule?.inputType === "percentage" &&
                                thenRule?.groupRule?.groupRule?.title &&
                                "%"}
                            </>
                          )
                        }
                        menuOptions={
                          thenRule.groupRule?.groupRule?.listType === "brand"
                            ? []
                            : thenRule.groupRule?.groupRule?.type === "select"
                              ? thenRule.groupRule?.groupRule?.options
                              : selectedRuleTypeRules?.thenRules || []
                        }
                        isOpen={thenRule.groupRule?.groupRule?.isOpen}
                        setOpen={() => {
                          let updatedThenRules = [...(updateRulesRef?.current?.thenRules || {})].map(
                            (rule) => {
                              if (
                                rule.groupRule?.groupRule.value ===
                                thenRule.groupRule?.groupRule.value &&
                                rule.groupRule?.groupRule
                              ) {
                                return {
                                  ...rule,
                                  groupRule: {
                                    ...rule.groupRule,
                                    groupRule: {
                                      ...rule.groupRule?.groupRule,
                                      isOpen: !rule.groupRule?.groupRule.isOpen,
                                    },
                                  },
                                };
                              }
                              return rule;
                            }
                          );
                          updateRulesRef.current = {
                            ...data,
                            thenRules: [...updatedThenRules],
                          };
                          setData({
                            ...data,
                            thenRules: updatedThenRules,
                          });
                        }}
                        ruleType="then"
                        rule="happen"
                        selectRuleHandler={({ ruleValue }) => {
                          if (
                            thenRule.groupRule?.groupRule?.type === "select" ||
                            thenRule.groupRule?.groupRule?.type === "list"
                          ) {
                            const selectedRule = [...updateRulesRef.current.thenRules]?.find(
                              (item) =>
                                item.groupRule?.groupRule?.value ===
                                thenRule.groupRule?.groupRule?.value
                            );
                            if (selectedRule) {
                              const index = data.thenRules.indexOf(selectedRule);
                              const needsList = ["products", "specific_product", "category", "brand"].includes(ruleValue);
                              const listType = ruleValue === "category" ? "category" : ruleValue === "brand" ? "brand" : "product";
                              const innerGroup = needsList
                                ? (selectedRule.groupRule?.groupRule?.groupRule
                                    ? {
                                        ...selectedRule.groupRule.groupRule.groupRule,
                                        listType,
                                        selectedValue: [],
                                      }
                                    : { title: "", value: listType, highlightText: "Select", type: "list", listType, isOpen: false, selectedValue: [] })
                                : selectedRule.groupRule?.groupRule?.groupRule;
                              let existingRule = [...data.thenRules];
                              existingRule[index] = {
                                ...selectedRule,
                                isOpen: false,
                                isShowError: false,
                                groupRule: {
                                  ...selectedRule.groupRule,
                                  groupRule: {
                                    ...selectedRule.groupRule?.groupRule,
                                    selectedValue: ruleValue,
                                    isShowError: false,
                                    ...(innerGroup != null && { groupRule: innerGroup }),
                                  },
                                },
                              };
                              updateRulesRef.current = {
                                ...data,
                                thenRules: [...existingRule],
                              };
                              setData({
                                ...data,
                                thenRules: existingRule,
                              });
                            }
                            return;
                          }
                          if (thenRule.groupRule?.groupRule?.type === "input") {
                            const updatedRules = [...updateRulesRef.current.thenRules].map((rule) => {
                              if (rule.groupRule?.groupRule?.value === thenRule.groupRule?.groupRule?.value) {
                                return {
                                  ...rule,
                                  groupRule: {
                                    ...rule.groupRule,
                                    groupRule: {
                                      ...rule.groupRule.groupRule,
                                      selectedValue: ruleValue,
                                      isShowError: false,
                                    },
                                  },
                                };
                              }
                              return rule;
                            });
                            updateRulesRef.current = { ...data, thenRules: updatedRules };
                            setData({ ...data, thenRules: updatedRules });
                            return;
                          }
                          if (thenRule.type === "input") {
                            const updatedRules = updateRuleValue({
                              rules: updateRulesRef.current.thenRules,
                              ruleValue,
                              ruleId: thenRule.value,
                              isGroupRule: thenRule.isGroupRule,
                            });
                            setData({
                              ...data,
                              thenRules: updatedRules,
                            });
                            return;
                          }
                          let existingRule = [...data.thenRules];
                          const selectedRule = selectedRuleTypeRules?.thenRules?.find(
                            (item) => item.value === ruleValue
                          );
                          if (selectedRule) {
                            existingRule = [...existingRule, selectedRule];
                          }
                          const thenRuleArray = data.thenRules.some((item) =>
                            selectedRuleTypeRules?.thenRules?.find(
                              (_item) => _item.value === item.value
                            )
                          );
                          if (thenRuleArray) {
                            let findRule = data.thenRules.find((item) =>
                              selectedRuleTypeRules?.thenRules?.find(
                                (_item) => _item.value === item.value
                              )
                            );
                            if (findRule) {
                              existingRule = existingRule.filter(
                                (item) => item.value !== findRule?.value
                              );
                            }
                          }
                          setData({
                            ...data,
                            thenRules: existingRule,
                          });
                        }}
                        rules={selectedRuleTypeRules.thenRules}
                        type={thenRule.groupRule?.groupRule?.type}
                        inputType={thenRule.groupRule?.groupRule?.inputType}
                        listType={thenRule.groupRule?.groupRule?.listType}
                        ruleId={thenRule.groupRule?.groupRule?.value}
                        inputValue={thenRule.groupRule?.groupRule.selectedValue}
                        isGroupRule={true}
                        showError={thenRule?.groupRule?.groupRule?.isShowError}
                      />
                      {<span>{thenRule?.groupRule?.groupRule?.endTitle}</span>}

                      {/* group level three  */}

                      {thenRule?.groupRule?.groupRule &&
                        thenRule.groupRule?.groupRule?.groupRule &&
                        ["products", "specific_product", "category", "brand"].includes(thenRule.groupRule.groupRule?.selectedValue) && (
                          <>
                            {thenRule.groupRule?.groupRule?.groupRule &&
                              thenRule.groupRule?.groupRule?.groupRule.title && (
                                <span>{thenRule.groupRule?.groupRule?.groupRule.title}</span>
                              )}
                            <DropdownMenuDemo
                              key={thenRule.groupRule?.groupRule?.groupRule.value}
                              menuTrigger={
                                <>
                                  {thenRule?.groupRule?.groupRule?.groupRule?.inputType ===
                                    "dollar" &&
                                    thenRule?.groupRule?.groupRule?.groupRule?.title &&
                                    "$"}
                                  {Array.isArray(
                                    thenRule?.groupRule?.groupRule?.groupRule?.selectedValue
                                  ) ? (
                                    thenRule.groupRule?.groupRule?.groupRule.selectedValue?.length >
                                      0 ? (
                                      <>
                                        {thenRule.groupRule?.groupRule?.groupRule.selectedValue
                                          ?.slice(0, 2)
                                          .map((value) =>
                                            thenRule.groupRule?.groupRule?.groupRule?.listType ===
                                              "category"
                                              ? `${value?.categoryName}`
                                              : thenRule.groupRule?.groupRule?.groupRule?.listType ===
                                                "brand"
                                                ? `${value?.brandName}`
                                                : `${value?.display_name} - ${value?.SKU}`
                                          )
                                          .join(", ") ||
                                          thenRule.groupRule?.groupRule?.groupRule.highlightText ||
                                          "Select"}
                                        {thenRule.groupRule?.groupRule?.groupRule.selectedValue
                                          .length > 2 && (
                                            <span
                                              className="chip"
                                              data-tooltip-id="tooltip"
                                              data-tooltip-content={
                                                thenRule.groupRule?.groupRule?.groupRule.selectedValue
                                                  .map((value) =>
                                                    thenRule.groupRule?.groupRule?.groupRule
                                                      ?.listType === "category"
                                                      ? `${value?.categoryName}`
                                                      : thenRule.groupRule?.groupRule?.groupRule
                                                        ?.listType === "brand"
                                                        ? `${value?.brandName}`
                                                        : `${value?.display_name} - ${value?.SKU}`
                                                  )
                                                  .join(", ") ||
                                                thenRule.groupRule?.groupRule?.groupRule
                                                  .highlightText ||
                                                "Select"
                                              }
                                            >{`+${thenRule.groupRule?.groupRule?.groupRule.selectedValue
                                              .length - 2
                                              }`}</span>
                                          )}
                                      </>
                                    ) : (
                                      thenRule.groupRule?.groupRule?.groupRule.highlightText ||
                                      "Select"
                                    )
                                  ) : isObject(
                                    thenRule?.groupRule?.groupRule?.groupRule?.selectedValue
                                  ) ? (
                                    thenRule?.groupRule?.groupRule?.groupRule?.listType ===
                                      "category" ? (
                                      thenRule?.groupRule?.groupRule?.groupRule?.selectedValue
                                        ?.categoryName || "category"
                                    ) : thenRule?.groupRule?.groupRule?.groupRule?.listType ===
                                      "brand" ? (
                                      thenRule?.groupRule?.groupRule?.groupRule?.selectedValue
                                        ?.brandName || "brand"
                                    ) : (
                                      thenRule?.groupRule?.groupRule?.groupRule?.selectedValue
                                        ?.display_name || "product"
                                    )
                                  ) : thenRule?.groupRule?.groupRule?.groupRule?.selectedValue ===
                                    "any_product" ? (
                                    "Then Get Any Product"
                                  ) : (
                                    thenRule?.groupRule?.groupRule?.groupRule?.selectedValue ||
                                    thenRule.groupRule?.groupRule?.groupRule?.highlightText ||
                                    "select"
                                  )}
                                  {thenRule?.groupRule?.groupRule?.groupRule?.inputType ===
                                    "percentage" &&
                                    thenRule?.groupRule?.groupRule?.groupRule?.title &&
                                    "%"}
                                </>
                              }
                              menuOptions={
                                thenRule.groupRule?.groupRule?.groupRule?.listType === "brand"
                                  ? []
                                  : thenRule.groupRule?.groupRule?.groupRule.type === "select"
                                    ? thenRule.groupRule?.groupRule?.groupRule.options
                                    : selectedRuleTypeRules.thenRules || []
                              }
                              isOpen={thenRule.groupRule?.groupRule?.groupRule.isOpen}
                              setOpen={() => {
                                let updatedThenRules = [...updateRulesRef.current.thenRules].map(
                                  (rule) => {
                                    if (
                                      rule.groupRule?.groupRule?.groupRule.value ===
                                      thenRule.groupRule?.groupRule?.groupRule?.value &&
                                      rule.groupRule?.groupRule?.groupRule
                                    ) {
                                      return {
                                        ...rule,
                                        groupRule: {
                                          ...rule.groupRule,
                                          groupRule: {
                                            ...rule.groupRule.groupRule,
                                            groupRule: {
                                              ...rule.groupRule.groupRule.groupRule,
                                              isOpen: !rule.groupRule.groupRule.groupRule.isOpen,
                                            },
                                          },
                                        },
                                      };
                                    }
                                    return rule;
                                  }
                                );
                                updateRulesRef.current = {
                                  ...data,
                                  thenRules: [...updatedThenRules],
                                };
                                setData({
                                  ...data,
                                  thenRules: updatedThenRules,
                                });
                              }}
                              ruleType="then"
                              rule="happen"
                              selectRuleHandler={({ ruleValue }) => {
                                if (
                                  thenRule.groupRule?.groupRule?.groupRule?.type === "select" ||
                                  thenRule.groupRule?.groupRule?.groupRule?.type === "list"
                                ) {
                                  const selectedRule = [...updateRulesRef.current.thenRules]?.find(
                                    (item) =>
                                      item.groupRule?.groupRule?.groupRule?.value ===
                                      thenRule.groupRule?.groupRule?.groupRule?.value
                                  );
                                  if (selectedRule) {
                                    const index = data.thenRules.indexOf(selectedRule);
                                    let existingRule = [...data.thenRules];
                                    existingRule[index] = {
                                      ...selectedRule,
                                      isOpen: false,
                                      isShowError: false,
                                      groupRule: {
                                        ...selectedRule.groupRule,
                                        groupRule: {
                                          ...selectedRule.groupRule.groupRule,
                                          groupRule: {
                                            ...selectedRule.groupRule.groupRule.groupRule,
                                            // isOpen: !selectedRule.groupRule.groupRule.groupRule.isOpen,
                                            selectedValue: ruleValue,
                                          },
                                        },
                                      },
                                    };
                                    updateRulesRef.current = {
                                      ...data,
                                      thenRules: [...existingRule],
                                    };
                                    setData({
                                      ...data,
                                      thenRules: existingRule,
                                    });
                                  }
                                  return;
                                }
                                if (thenRule.type === "input") {
                                  const updatedRules = updateRuleValue({
                                    rules: updateRulesRef.current.thenRules,
                                    ruleValue,
                                    ruleId: thenRule.value,
                                    isGroupRule: thenRule.isGroupRule,
                                  });
                                  setData({
                                    ...data,
                                    thenRules: updatedRules,
                                  });
                                  return;
                                }
                                let existingRule = [...data.thenRules];
                                const selectedRule = selectedRuleTypeRules?.thenRules?.find(
                                  (item) => item.value === ruleValue
                                );
                                if (selectedRule) {
                                  existingRule = [...existingRule, selectedRule];
                                }
                                const thenRuleArray = data.thenRules.some((item) =>
                                  selectedRuleTypeRules?.thenRules?.find(
                                    (_item) => _item.value === item.value
                                  )
                                );
                                if (thenRuleArray) {
                                  let findRule = data.thenRules.find((item) =>
                                    selectedRuleTypeRules?.thenRules?.find(
                                      (_item) => _item.value === item.value
                                    )
                                  );
                                  if (findRule) {
                                    existingRule = existingRule.filter(
                                      (item) => item.value !== findRule?.value
                                    );
                                  }
                                }
                                setData({
                                  ...data,
                                  thenRules: existingRule,
                                });
                              }}
                              rules={selectedRuleTypeRules.thenRules}
                              type={thenRule.groupRule?.groupRule?.groupRule?.type}
                              inputType={thenRule.groupRule?.groupRule?.groupRule?.inputType}
                              listType={thenRule.groupRule?.groupRule?.groupRule?.listType}
                              ruleId={thenRule.groupRule?.groupRule?.groupRule?.value}
                              inputValue={thenRule.groupRule?.groupRule?.groupRule?.selectedValue}
                              isGroupRule={true}
                              showError={thenRule?.groupRule?.groupRule?.groupRule?.isShowError}
                            />
                            {<span>{thenRule.groupRule?.groupRule?.groupRule?.endTitle}</span>}
                          </>
                        )}

                      {/* group level three  */}
                    </>
                  )}
              </>
            )}
          </React.Fragment>
        ))}
      </div>

    </div>
  );
}
